import { IconSVG } from '../types';

export function Information({ size, style }: IconSVG) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      style={style}
      viewBox="0 0 40 40"
    >
      <path
        fill="#704300"
        d="M20.5 28.832q.708 0 1.188-.48.48-.478.479-1.187V20.5q0-.709-.48-1.188-.479-.48-1.187-.479-.708 0-1.187.48-.48.478-.48 1.187v6.666q0 .709.48 1.188.48.48 1.187.479m0-13.333q.708 0 1.188-.48.48-.479.479-1.187 0-.708-.48-1.187-.479-.48-1.187-.48t-1.187.48q-.48.479-.48 1.187t.48 1.188q.48.479 1.187.479m0 21.666q-3.458 0-6.5-1.312T8.71 32.29 5.146 27t-1.312-6.5 1.312-6.5 3.563-5.292T14 5.145t6.5-1.313T27 5.145t5.292 3.562 3.562 5.292q1.313 3.04 1.313 6.5 0 3.458-1.313 6.5-1.312 3.04-3.562 5.291-2.25 2.25-5.292 3.563-3.041 1.312-6.5 1.312m0-3.333q5.583 0 9.459-3.875t3.875-9.458-3.876-9.459T20.5 7.165t-9.458 3.875T7.167 20.5t3.875 9.458 9.458 3.875"
      />
    </svg>
  );
}
